import { ApexOptions } from "ng-apexcharts";
import { CHART_CATEGORICAL_PALETTE, CHART_STYLE } from "./chart-tokens";

type AxisChartType = "bar" | "heatmap" | "line";
type BarPlotOptions = NonNullable<ApexOptions["plotOptions"]>["bar"];
type ChartHeight = ApexOptions["chart"] extends { height?: infer Height }
  ? Height
  : number | string;

export function createAxisChartDefaults(
  type: AxisChartType,
  height: ChartHeight,
): ApexOptions {
  return {
    chart: {
      animations: { speed: CHART_STYLE.animationSpeed },
      fontFamily: "inherit",
      foreColor: "inherit",
      height,
      toolbar: { show: false },
      type,
      zoom: { enabled: false },
    },
    colors: [...CHART_CATEGORICAL_PALETTE],
    dataLabels: { enabled: false },
    grid: { borderColor: CHART_STYLE.gridColor },
    states: {
      active: { filter: { type: "none" } },
      hover: { filter: { type: "darken" } },
    },
    tooltip: { theme: "dark" },
    xaxis: {
      axisBorder: { show: false },
      axisTicks: { color: CHART_STYLE.gridColor },
      labels: { style: { colors: CHART_STYLE.textColor } },
      tooltip: { enabled: false },
    },
    yaxis: {
      labels: { style: { colors: CHART_STYLE.textColor } },
    },
  };
}

export function createBarPlotOptions(horizontal = false): BarPlotOptions {
  return {
    barHeight: horizontal ? CHART_STYLE.barSize : undefined,
    borderRadius: CHART_STYLE.barBorderRadius,
    borderRadiusApplication: "end",
    borderRadiusWhenStacked: "last",
    columnWidth: horizontal ? undefined : CHART_STYLE.barSize,
    horizontal,
  };
}

export function createDonutChartDefaults(height: ChartHeight): ApexOptions {
  return {
    chart: {
      animations: {
        animateGradually: { enabled: false },
        speed: CHART_STYLE.animationSpeed,
      },
      fontFamily: "inherit",
      foreColor: "inherit",
      height,
      sparkline: { enabled: true },
      type: "donut",
    },
    colors: [...CHART_CATEGORICAL_PALETTE],
    plotOptions: {
      pie: { customScale: 0.92, expandOnClick: false, donut: { size: "70%" } },
    },
    states: {
      active: { filter: { type: "none" } },
      hover: { filter: { type: "none" } },
    },
    tooltip: { enabled: true, fillSeriesColor: false, theme: "dark" },
  };
}
